import styled from 'styled-components';

export const StyledH4 = styled.h4`
  margin: 0;
  padding: 30px;
  height: 50px;
`;
